<template>
    <q-table
        ref="table"
        :data="data"
        :columns="columns"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="request"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
            {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="group_training_test_title" :props="props">
                    {{ props.row.group_training_test_title }}
                </q-td>

                <q-td key="group_training_title" :props="props">
                    {{ props.row.group_training_title }}
                </q-td>

                <q-td key="group_training_test_type" :props="props">
                    {{ $t(props.row.group_training_test_type) }}
                </q-td>

                <q-td key="qty_questions" :props="props">
                    {{ props.row.qty_questions }}
                </q-td>

                <q-td key="score" :props="props">
                    {{ props.row.score ? props.row.score.toFixed(2) : '' }}
                </q-td>

                <q-td key="percent" :props="props">
                    {{ props.row.percent ? `${props.row.percent.toFixed(2)}%` : '' }}
                </q-td>

                <q-td key="group_training_test_user_score" :props="props">
                    {{ props.row.group_training_test_user_score ? props.row.group_training_test_user_score.toFixed(2) : '-' }}
                </q-td>

                <q-td key="result_date" :props="props">
                    {{ getDateFormated(props.row.result_date) }}
                </q-td>

				<q-td key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)"  :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'UserReportCourseTestsTab',

    data() {
        return {
            loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'group_training_test_title',
                    required: true,
                    label: 'test',
                    align: 'left',
                    field: 'group_training_test_title',
                    sortable: false,
                },
                {
                    name: 'group_training_title',
                    required: true,
                    label: 'training',
                    align: 'left',
                    field: 'group_training_title',
                    sortable: false,
                },
                {
                    name: 'group_training_test_type',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'group_training_test_type',
                    sortable: false,
                },
                {
                    name: 'qty_questions',
                    required: true,
                    label: 'questions',
                    align: 'left',
                    field: 'qty_questions',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'hits',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'percent',
                    required: true,
                    label: 'percent',
                    align: 'left',
                    field: 'percent',
                    sortable: false,
                },
                {
                    name: 'group_training_test_user_score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'group_training_test_user_score',
                    sortable: false,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: false,
				},
				{
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_group_training_test_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.data = []

                response.data.results.forEach(result => {
                    this.data.push(result)
                })
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        getDateFormated(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
		},

		getStatus(status) {
			switch(status) {
                case 1: return 'aproved'
                break
                case 2: return 'reproved'
                break
                case 3: return 'blocked'
                break
                case 4: return 'restarted_training'
                break
                case 50: 
                case 5: return 'improved_score'
                break
                case 60: return 'not_improved_score'
                break
            }
		},

        getColorStatus(status) {
             switch(status) {
                case 1:
                case 50: 
                case 5: return 'positive'
                break
                case 2:
                case 3: return 'negative'
                break
                case 4: return 'warning'
                break
                case 60: return ''
                break
            }
		},
		getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-ban'
            else if (status == 4) return 'fas fa-sync'
            else if (status == 5 || status == 50) return 'fas fa-check'
            else if (status == 6) return 'fas fa-star'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.request({ pagination: this.server_pagination })
    }
}
</script>

<style>
</style>
